<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricoes[index])'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroDoProcesso') }}:
                |
                | {{ restricao.processo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroAuto') }}:
                |
                | {{ restricao.auto || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
                |
                | {{ restricao.cpf_cnpj || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                |
                | {{ restricao.nome_razao_social_do_autuado || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataAutuacao') }}:
                |
                | {{ restricao.data_autuacao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio') }}:
                |
                | {{ restricao.municipio_da_autuacao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tipoInfracao') }}:
                |
                | {{ restricao.tipo_infracao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.situacao') }}:
                |
                | {{ restricao.situacao_do_embargo || '-' }}
                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
            </template>
            
<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'lista-area-embargada-piaui',

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
